export default "__VITE_ASSET__D_q04o60__"